import UserOrder from "./UserOrder";
import UserOrdersFilter from "./UserOrdersFilter";

export default class UserOrders {
  constructor() {
    this.setInitialValue();
  }
  setInitialValue() {
    this.status = 0;
    this.msg = "";
    this.listSort = [];
    this.userOrdersData = [];
    this.userOrder = new UserOrder();
    this.filterData = new UserOrdersFilter();
  }
  fillData(data) {
    if (data) {
      this.status = data.status;
      this.msg = data.msg;
      this.listSort = data.listSort ?? [];
      let filter = { ...this.filterData, ...data.pagination };
      this.filterData.fillData(filter);
      this.userOrdersData = data.userOrdersData ?? [];
    } else {
      this.setInitialValue();
    }
  }
}
